function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Business_ic_mid"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.26 68.22c-10.47 0-20.34-4.72-27.77-13.63a2 2 0 113.07-2.56c9.19 11 22.52 14.86 35.65 10.29l84.72-30.19a24.14 24.14 0 0015.08-15.43 24.13 24.13 0 00-21.39-2.73L97.27 25.72a2 2 0 01-1.34-3.77l33.36-11.82a28.13 28.13 0 0126.24 4.09 2 2 0 01.73 2.1 28.13 28.13 0 01-18 19.51L53.54 66.04a37.27 37.27 0 01-12.28 2.18z",
  fill: "#676767"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.59 47.8a2 2 0 01-.67-3.89l33.6-11.9a2 2 0 111.34 3.77l-33.6 11.9a2 2 0 01-.67.12z",
  fill: "#676767"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.26 42.06a2 2 0 01-1.43-.6L39.16 7.22a2 2 0 01.77-3.29L49.32.66a12 12 0 019.31.61l48.41 25.87a2 2 0 11-1.88 3.53L56.76 4.83a8 8 0 00-6.15-.38l-6.45 2.22 31.48 32a2 2 0 01-1.43 3.4zM146.16 110.22h-136a2 2 0 110-4h136a2 2 0 010 4z",
  fill: "#676767"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.02 55.22a2 2 0 01-1.55-.74l-13-16a2 2 0 01.78-3.11l6-2.53h.11a10.53 10.53 0 018.1.46l20.08 10.74a2 2 0 01-.23 3.63l-19.58 7.46a2 2 0 01-.71.09zM5.24 38.04l10.42 12.84 14.13-5.39-16.13-8.65a6.52 6.52 0 00-4.91-.27z",
  fill: "#e60000"
})));

var SvgRoamingMid = function SvgRoamingMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 156.32 110.22",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgRoamingMid;